import Keycloak from "keycloak-js";
import config from "./config";

// ✅ Ensure this instance is created ONCE
const keycloakInstance = new Keycloak({
    url: config.keycloak.url,
    realm: config.keycloak.realm,
    clientId: config.keycloak.clientId,
});

export default keycloakInstance; // ✅ Always export the same instance
